import { render, staticRenderFns } from "./BuzonUser.vue?vue&type=template&id=6f0c200a&scoped=true&"
import script from "./BuzonUser.vue?vue&type=script&lang=js&"
export * from "./BuzonUser.vue?vue&type=script&lang=js&"
import style0 from "./BuzonUser.vue?vue&type=style&index=0&id=6f0c200a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0c200a",
  null
  
)

export default component.exports